import { useState } from 'react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../data/siteData';

export default function ContactForm({ variant = 'banner', defaultOpen = false }) {
  const [showForm, setShowForm] = useState(defaultOpen);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    subject: 'salg_guld_soelv',
    message: '',
    website_url: '' // Honeypot field
  });

  const [status, setStatus] = useState('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    setErrorMessage('');

    try {
      const response = await fetch('https://api.dev.auxo.dk/webform/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const resData = await response.json();

      if (response.ok && resData.status === 'ok') {
        setStatus('success');
        setFormData({
          name: '',
          phone: '',
          email: '',
          subject: 'salg_guld_soelv',
          message: '',
          website_url: ''
        });
      } else {
        setStatus('error');
        setErrorMessage(resData.message || 'Der opstod en fejl ved afsendelse. Prøv venligst igen.');
      }
    } catch (err) {
      console.error('Fejl ved indsendelse af kontaktformular:', err);
      setStatus('error');
      setErrorMessage('Der kunne ikke oprettes forbindelse til serveren. Kontrollér din internetforbindelse eller ring til os.');
    }
  };

  if (variant === 'banner') {
    return (
      <div className="w-full bg-[#0d132c] border border-white/10 p-8 sm:p-12 lg:p-14 text-center rounded-none shadow-none text-white">
        <div className="max-w-2xl mx-auto space-y-4">
          <div className="w-[1px] h-8 bg-[#B5A897] mx-auto mb-3"></div>
          <span className="text-[10px] sm:text-xs uppercase tracking-[0.25em] text-[#B5A897] font-semibold block">
            KONTAKT OS
          </span>
          <h3 className="font-serif text-2xl sm:text-3xl font-normal uppercase tracking-[0.15em] text-white">
            VI STÅR KLAR TIL AT HJÆLPE DIG
          </h3>
          <p className="text-xs sm:text-sm text-stone-300 font-sans leading-relaxed max-w-lg mx-auto pb-2">
            Har du spørgsmål til reparationer, vurdering af guld eller vores udvalg?<br className="hidden sm:inline" /> Du er altid velkommen til at kontakte os eller kigge forbi butikken.
          </p>
          <div className="pt-2">
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center gap-2 border border-[#B5A897] bg-[#B5A897] text-[#0d132c] hover:bg-transparent hover:text-white transition-all text-xs tracking-[0.2em] uppercase px-8 py-3.5 font-medium cursor-pointer"
            >
              <span>KONTAKT OS</span>
              <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true"></i>
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#F2EFE9] border border-[#E2DDD3] p-8 sm:p-10 rounded-none shadow-none text-left">
      <div className="mb-6">
        <span className="text-[10px] uppercase tracking-[0.25em] text-[#B5A897] font-semibold block mb-1">
          KONTAKT OS
        </span>
        <h3 className="font-serif text-2xl sm:text-3xl font-normal uppercase tracking-[0.15em] text-[#1A1A1A]">
          SEND OS EN HENVENDELSE
        </h3>
        <p className="text-xs text-stone-600 mt-2 leading-relaxed">
          Udfyld formularen herunder, så vender vi hurtigt tilbage til dig.
        </p>
      </div>

      {status === 'success' ? (
        <div className="bg-[#F9F8F6] border border-[#B5A897] p-8 text-center space-y-4 rounded-none animate-in fade-in duration-300">
          <div className="w-12 h-12 bg-[#0B132B] text-white rounded-none flex items-center justify-center mx-auto text-lg">
            <i className="fa-solid fa-check" aria-hidden="true"></i>
          </div>
          <h4 className="font-serif text-2xl font-normal uppercase tracking-wider text-[#1A1A1A]">
            TAK FOR DIN HENVENDELSE!
          </h4>
          <p className="text-xs text-stone-600 leading-relaxed max-w-sm mx-auto">
            Vi har modtaget din besked og kontakter dig hurtigst muligt.
          </p>
          <button
            onClick={() => setStatus('idle')}
            className="inline-block border-b border-[#1A1A1A] pb-1 text-xs uppercase tracking-[0.2em] font-medium text-[#1A1A1A] hover:text-[#B5A897] hover:border-[#B5A897] transition-all cursor-pointer pt-2"
          >
            SEND EN NY BESKED
          </button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5">
          
          {/* Honeypot Field */}
          <div className="sr-only absolute left-0 top-0 opacity-0 pointer-events-none -z-50" aria-hidden="true">
            <label htmlFor="website_url">Honeypot</label>
            <input
              type="text"
              id="website_url"
              name="website_url"
              value={formData.website_url}
              onChange={handleChange}
              tabIndex={-1}
              autoComplete="off"
            />
          </div>

          {/* Emne / Kategori */}
          <div>
            <label className="block text-[10px] font-semibold uppercase tracking-[0.2em] text-[#1A1A1A] mb-2">
              Hvad drejer din henvendelse sig om?
            </label>
            <select
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              className="w-full px-4 py-3 bg-[#F9F8F6] border border-[#E2DDD3] text-xs uppercase tracking-wider text-[#1A1A1A] focus:outline-none focus:border-[#0B132B] rounded-none cursor-pointer"
            >
              <option value="salg_guld_soelv">Salg af guld & sølv (Vurdering)</option>
              <option value="smykke_design">Specialdesign af smykke</option>
              <option value="smykke_reparation">Smykkereparation / Værksted</option>
              <option value="ur_reparation">Urereparation & Batteriskift</option>
              <option value="andet">Generel henvendelse</option>
            </select>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {/* Navn */}
            <div>
              <label className="block text-[10px] font-semibold uppercase tracking-[0.2em] text-[#1A1A1A] mb-2">
                Navn <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="name"
                required
                value={formData.name}
                onChange={handleChange}
                placeholder="DIT FULDE NAVN"
                className="w-full px-4 py-3 bg-[#F9F8F6] border border-[#E2DDD3] text-xs text-[#1A1A1A] placeholder:text-stone-400 focus:outline-none focus:border-[#0B132B] rounded-none"
              />
            </div>

            {/* Telefon */}
            <div>
              <label className="block text-[10px] font-semibold uppercase tracking-[0.2em] text-[#1A1A1A] mb-2">
                Telefonnummer <span className="text-red-500">*</span>
              </label>
              <input
                type="tel"
                name="phone"
                required
                value={formData.phone}
                onChange={handleChange}
                placeholder="TLF. NR."
                className="w-full px-4 py-3 bg-[#F9F8F6] border border-[#E2DDD3] text-xs text-[#1A1A1A] placeholder:text-stone-400 focus:outline-none focus:border-[#0B132B] rounded-none"
              />
            </div>
          </div>

          {/* Email */}
          <div>
            <label className="block text-[10px] font-semibold uppercase tracking-[0.2em] text-[#1A1A1A] mb-2">
              E-mailadresse <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              name="email"
              required
              value={formData.email}
              onChange={handleChange}
              placeholder="DIN@EMAIL.DK"
              className="w-full px-4 py-3 bg-[#F9F8F6] border border-[#E2DDD3] text-xs text-[#1A1A1A] placeholder:text-stone-400 focus:outline-none focus:border-[#0B132B] rounded-none"
            />
          </div>

          {/* Besked */}
          <div>
            <label className="block text-[10px] font-semibold uppercase tracking-[0.2em] text-[#1A1A1A] mb-2">
              Beskrivelse <span className="text-red-500">*</span>
            </label>
            <textarea
              name="message"
              required
              rows={4}
              value={formData.message}
              onChange={handleChange}
              placeholder="BESKRIV HVAD VI KAN HJÆLPE DIG MED..."
              className="w-full px-4 py-3 bg-[#F9F8F6] border border-[#E2DDD3] text-xs text-[#1A1A1A] placeholder:text-stone-400 focus:outline-none focus:border-[#0B132B] rounded-none"
            ></textarea>
          </div>

          {status === 'error' && (
            <div className="p-3 bg-red-50 border border-red-200 text-red-700 text-xs rounded-none flex items-center gap-2">
              <i className="fa-solid fa-circle-exclamation text-base text-red-500" aria-hidden="true"></i>
              <span>{errorMessage}</span>
            </div>
          )}

          <button
            type="submit"
            disabled={status === 'submitting'}
            className="w-full py-4 px-6 border border-[#0B132B] text-[#0B132B] bg-transparent hover:bg-[#0B132B] hover:text-white transition-all text-xs tracking-[0.25em] uppercase rounded-none font-medium cursor-pointer flex items-center justify-center gap-2"
          >
            {status === 'submitting' ? (
              <>
                <div className="w-4 h-4 border-2 border-[#0B132B] border-t-transparent animate-spin"></div>
                <span>SENDER HENVENDELSE...</span>
              </>
            ) : (
              <span>SEND HENVENDELSE</span>
            )}
          </button>
        </form>
      )}
    </div>
  );
}
